import { AttachmentFileList, AttachmentFileType } from 'owa-attachment-file-types';
import { InsertLinksHost } from 'owa-attachment-link-common';
import { ShouldShareAttachment } from 'owa-attachment-well-data';
import { confirm } from 'owa-confirm-dialog';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import loc from 'owa-localize';
import { closeButtonLabel } from 'owa-locstrings/lib/strings/closebuttonlabel.locstring.json';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import * as trace from 'owa-trace';
import { insertLinksIntoComposeEditor } from '../insertLinksFromFilePicker/insertLinksIntoComposeEditor';
import {
    BrowseCloudLocationsOnlyAllowOneFile,
    CouldNotInsertHyperLinkTitle,
} from './openFilePicker.locstring.json';
import { getUpsellUserSelectionText } from './upsellUserSelectionText';

export async function insertLinks(
    files: AttachmentFileList,
    insertLinksHost: InsertLinksHost,
    editorViewState: EditorViewState,
    fromAddress: string,
    targetWindow: Window,
    sxsId: string,
    selectionText?: string, // This is for hyperlink entry scenario where user selects typed text as the display text of the insert link,
    upsellProperties?: ShouldShareAttachment
) {
    if (!files || files.length === 0) {
        trace.errorThatWillCauseAlert('No files for inserting link from filepicker');
        return;
    }

    let userSeletionText: string = selectionText;

    if (files[0].fileType === AttachmentFileType.Local) {
        // VSTO: 83276 implementing upsell for group

        userSeletionText = getUpsellUserSelectionText();
        if (userSeletionText && files.length > 1) {
            await confirm(
                loc(CouldNotInsertHyperLinkTitle),
                loc(BrowseCloudLocationsOnlyAllowOneFile),
                false /*resolveImmediately*/,
                {
                    hideCancelButton: true,
                    okText: loc(closeButtonLabel),
                }
            );
            return;
        }
    }

    const getRecipientWells = (): RecipientWellWithFindControlViewState[] => [
        insertLinksHost.toRecipientWell,
        insertLinksHost.ccRecipientWell,
        insertLinksHost.bccRecipientWell,
    ];

    insertLinksIntoComposeEditor(
        editorViewState,
        files,
        insertLinksHost.attachmentWell,
        getRecipientWells,
        fromAddress,
        targetWindow,
        sxsId,
        userSeletionText,
        upsellProperties?.shouldShare ? upsellProperties.shareProperties : null
    );
}
